<template>
  <div class="res-and-list">
    <div class="response-box-header">
      <div class="header-left">
        <span class="response-title">Student Responses</span>
        <span class="answered-ratio">{{ answeredCount }}/{{ totalStudentsCount }} answered</span>
      </div>
      <div class="expand-action" title="Expand responses" @click="handleExpand">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00BFA5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 3 3 3 3 9"></polyline>
          <polyline points="15 3 21 3 21 9"></polyline>
          <polyline points="9 21 3 21 3 15"></polyline>
          <polyline points="15 21 21 21 21 15"></polyline>
        </svg>
      </div>
    </div>
    <ul class="res-list" v-if="tab === 1">
      <li class="student-list-item" v-for="item in studentList.slice(0, 200)" :key="item._id">
        <img src="../../assets/picture/student-answered.png" class="ans-status" v-if="answeredStudents.indexOf(item._id) > -1" />
        <img src="../../assets/picture/student-no-ans.png" class="ans-status" v-else />
        <div class="user-icon student-icon">{{ item.name ? item.name.substr(0, 2) : '' }}</div>
        <div class="user-name">{{ item.name }}</div>
      </li>
    </ul>
    <ul class="res-list" v-if="tab === 2">
      <!-- <div  class="showResButoon">{{showResponse ? 'Hide' : 'Show'}} Response</div> -->
      <template v-if="answerList.length > 0">
        <div v-if="getQuestion.type === 'comment'">
          <div v-for="(user, userId) in commentData" :key="userId" class="user-container">
            <div class="user-header">
              <button @click="toggleShow(userId)">
                {{ user.nickname }} <span>{{ userVisibility[userId] ? '&#9650;' : '&#9660;' }}</span>
              </button>
              <div v-if="userVisibility[userId]" style="margin-top: 12px;">
                <li class="res-list-item" v-for="item in user.allPointers" :key="item._id">
                  <div class="close-response-card">
                    <div class="close-card-header">
                      <div class="close-card-avatar-wrap">
                        <img v-if="getStudent(item) && getStudent(item).avatar" :src="urlProxy(getStudent(item).avatar)" class="close-card-img-avatar" />
                        <div v-else class="close-card-def-avatar">{{ getInitials(item) }}</div>
                      </div>
                      <div class="close-card-student-meta">
                        <span class="close-card-student-name">{{ getStudentName(item) }}</span>
                        <span class="close-card-student-time">{{ formatTime(item) }}</span>
                      </div>
                    </div>
                    <div class="close-card-answer-box">
                      <dash-right-comment-item :item="item" />
                    </div>
                    <!-- Bloom level to be implemented later
                    <div class="close-card-bloom">
                      <span>Bloom Level {{ getBloomLevel() }} · </span>
                      <span class="bloom-highlight">{{ getBloomLabel() }}</span>
                    </div>
                    -->
                  </div>
                </li>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <li class="res-list-item" v-for="item in answerList" :key="item._id">
            <div class="close-response-card">
              <!-- Top: Avatar + Student Name + Time -->
              <div class="close-card-header">
                <div class="close-card-avatar-wrap">
                  <img v-if="getStudent(item) && getStudent(item).avatar" :src="urlProxy(getStudent(item).avatar)" class="close-card-img-avatar" />
                  <div v-else class="close-card-def-avatar">{{ getInitials(item) }}</div>
                </div>
                <div class="close-card-student-meta">
                  <span class="close-card-student-name">{{ getStudentName(item) }}</span>
                  <span class="close-card-student-time">{{ formatTime(item) }}</span>
                </div>
              </div>

              <!-- Middle: Answer Container -->
              <div class="close-card-answer-box">
                <dash-right-media-item v-if="getQuestion.type === 'media'" :item="item" />
                <div v-else-if="getQuestion.type === 'draw'" class="remark-item-content-right" style="height: 150px">
                  <Base64image :url="Fn.hashToUrl(getPage.pic || getPage.url)">
                    <div class="del-answer flex_c" v-if="item.locked">Deleted response</div>
                    <Base64image v-else :url="item.content" />
                  </Base64image>
                </div>
                <div v-else class="close-card-answer-text" :class="!item.content && !item.answer && 'deleted-response'">
                  {{ getAnswerText(item) }}
                </div>
              </div>

              <!-- Bloom level to be implemented later
              <div class="close-card-bloom">
                <span>Bloom Level {{ getBloomLevel() }} · </span>
                <span class="bloom-highlight">{{ getBloomLabel() }}</span>
              </div>
              -->
            </div>
          </li>
        </div>
      </template>
      <loading-view v-else />
    </ul>
  </div>
</template>
<script>
import {getAnswerTimeStr} from '@/utils/help'
import {mapState, mapGetters} from 'vuex'
import studentInfo from '../common/studentInfo.vue'
import dashRightMediaItem from './dash-answer/dash-right-media-item.vue'
import DashRightCommentItem from './dash-answer/dash-right-comment-item.vue'
import Base64image from '@/components/base64image.vue'
import LoadingView from './loadingView.vue'
export default {
  components: {studentInfo, dashRightMediaItem, DashRightCommentItem, Base64image, LoadingView},
  computed: {
    ...mapState(['session', 'userList']),
    ...mapState('teacher', ['rooms']),
    ...mapState({
      studentList: (state) => state.teacher.studentList,
      allRemarks: (state) => state.remark.allRemarks,
      currentPageIndex: (state) => state.student.currentPageIndex,
    }),
    ...mapGetters(['getPageId', 'getPage', 'getQuestion']),
    ...mapGetters('student', ['currentPageAnswerList']),
    answeredCount() {
      const answeredSet = new Set()
      if (this.currentPageAnswerList && this.currentPageAnswerList.length) {
        for (const item of this.currentPageAnswerList) {
          const id = item.uid || item.user_id || item._id
          if (id) answeredSet.add(id)
        }
      }
      return answeredSet.size
    },
    totalStudentsCount() {
      if (this.rooms?.members && this.rooms.members.length > 0) {
        return Math.max(this.rooms.members.length, this.answeredCount)
      }
      if (this.studentList && this.studentList.length > 0) {
        return Math.max(this.studentList.length, this.answeredCount)
      }
      if (this.session?.students && this.session.students.length > 0) {
        return Math.max(this.session.students.length, this.answeredCount)
      }
      if (this.session?.regNum) {
        return Math.max(this.session.regNum, this.answeredCount)
      }
      return this.answeredCount || 0
    },
    // 已答题学生
    answeredStudents() {
      let anList = []
      for (let i = 0; i < this.studentList.length; i++) {
        const currentUser = this.studentList[i]
        const index = this.answerList.findIndex((item) => item._id === currentUser._id)
        if (index > -1) {
          anList.push(currentUser)
        }
      }
      // console.log(noList)
      return anList
    },
    currentComments() {
      let list = []
      if (this.getPageId && this.allRemarks.length > 0) {
        list = this.allRemarks.filter((item) => item.page_id === this.getPageId)
      }
      // list.reverse()
      console.log(list)
      return list
    },
    answerList() {
      Acan.arrSort(this.currentPageAnswerList, 'updatedAt', 1)
      return this.currentPageAnswerList
    },
    commentData() {
      return this.currentPageAnswerList.reduce((acc, item) => {
        const userId = item.uid

        if (!acc[userId]) {
          acc[userId] = {
            allPointers: [],
            nickname: item.nickname,
          }
        }

        acc[userId].allPointers.push(item)

        return acc
      }, {})
    },
  },
  props: {
    showResponse: {
      type: Boolean,
      default: false,
    },
    showres: {
      type: Function,
    },
  },
  data() {
    return {
      tab: 2,
      userVisibility: {},
    }
  },
  methods: {
    getStudent(item) {
      const uid = item.uid || item.user_id || item.from || item._id
      if (!uid) return item
      if (this.userList && !this.userList[uid]) {
        this.$store.dispatch('userInfo', uid)
      }
      if (this.studentList && this.studentList.length) {
        const found = this.studentList.find((s) => s._id === uid || s.uid === uid)
        if (found) return found
      }
      return (this.userList && this.userList[uid]) || item
    },
    getStudentName(item) {
      const u = this.getStudent(item)
      return u?.nickname || u?.name || item?.nickname || item?.name || 'Student Name'
    },
    getInitials(item) {
      const name = this.getStudentName(item)
      if (!name || name === 'Student Name') return 'SN'
      const parts = name.trim().split(/\s+/)
      if (parts.length >= 2 && parts[0] && parts[1]) {
        return (parts[0][0] + parts[1][0]).toUpperCase()
      }
      return name.slice(0, 2).toUpperCase()
    },
    formatTime(item) {
      const t = item.updatedAt || item.last || item.createdAt || item.time
      if (!t) return ''
      try {
        const d = new Date(typeof t === 'number' && t < 1e12 ? t * 1000 : t)
        if (isNaN(d.getTime())) return ''
        return (
          d.toLocaleDateString() +
          ' ' +
          d.toLocaleTimeString([], {hour: 'numeric', minute: '2-digit', second: '2-digit'})
        )
      } catch (e) {
        return ''
      }
    },
    getAnswerText(item) {
      if (!item) return 'Deleted Response'
      if (item.content && typeof item.content === 'string') {
        return item.content
      }
      if (item.answer !== undefined && item.answer !== null) {
        if (Array.isArray(item.answer)) {
          return item.answer.join(', ')
        }
        if (typeof item.answer === 'object') {
          return item.answer.text || item.answer.val || JSON.stringify(item.answer)
        }
        return String(item.answer)
      }
      return item.content || 'Deleted Response'
    },
    getBloomLevel() {
      const q = this.getQuestion
      if (q && q.bloom && q.bloom.length > 0) {
        return q.bloom[0] + 1
      }
      return 1
    },
    getBloomLabel() {
      const labels = ['Remember', 'Understand', 'Apply', 'Analyze', 'Evaluate', 'Create']
      const level = this.getBloomLevel()
      return labels[level - 1] || 'Remember'
    },
    handleExpand() {
      this.$store.dispatch('teacher/showMoreBtn', this.currentPageIndex)
    },
    changeTab(tab) {
      this.tab = tab
    },
    getTimeStr(time) {
      if (!time) return ''
      return getAnswerTimeStr(time * 1000)
    },
    toggleShow(userId) {
      this.userVisibility = {...this.userVisibility, [userId]: !this.userVisibility[userId]}
    },
  },
}
</script>

<style scoped>
.response-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 14px 18px;
  border-bottom: 1px solid #f1f5f9;
  background-color: #ffffff;
  box-sizing: border-box;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.response-title {
  font-size: 20px;
  font-weight: 500;
  color: #1e293b;
  letter-spacing: -0.2px;
}

.answered-ratio {
  font-size: 13px;
  color: #64748b;
  font-weight: 400;
}

.expand-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.expand-action:hover {
  background-color: rgba(0, 191, 165, 0.1);
}

.res-list {
  padding: 16px;
  margin: 0;
  list-style: none;
  overflow-y: auto;
  box-sizing: border-box;
  flex: 1;
}

.res-list-item {
  width: 100%;
  margin-bottom: 14px !important;
  padding: 0 !important;
  box-sizing: border-box;
  list-style: none;
}

.close-response-card {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;
}

.close-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.close-card-avatar-wrap {
  flex-shrink: 0;
}

.close-card-def-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #00875a;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.close-card-img-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}

.close-card-student-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 0;
}

.close-card-student-name {
  font-size: 14.5px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
}

.close-card-student-time {
  font-size: 11.5px;
  color: #94a3b8;
  font-weight: 400;
  line-height: 1.25;
}

.close-card-answer-box {
  background: #f8fafc;
  border-radius: 8px;
  padding: 14px 16px;
  margin: 14px 0 12px 0;
  min-height: 84px;
  box-sizing: border-box;
  word-break: break-word;
  display: flex;
  flex-direction: column;
}

.close-card-answer-text {
  font-size: 13.5px;
  color: #1e293b;
  line-height: 1.5;
}

.close-card-bloom {
  font-size: 12px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.close-card-bloom .bloom-highlight {
  font-weight: 600;
  color: #1e293b;
}

.user-container {
  border: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f9f9f9;
}

.user-header {
  font-weight: bold;
  margin-bottom: 5px;
}

button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

button span {
  margin-left: 10px;
}
</style>
